export default __webpack_public_path__ + "static/media/D3.43418445.png";